import React from "react";
import { StaticLedgerTableRow } from "./StaticLedgerTableRow";
import { TransactionOverviewLedgerEntry } from "./TransactionOverviewLedgerEntry";

export function StaticLedgerSection({
  ledgers,
}: {
  ledgers: TransactionOverviewLedgerEntry[];
}): React.ReactElement {
  return (
    <>
      {ledgers.map(({ ledger }) => (
        <StaticLedgerTableRow ledger={ledger} key={ledger._id} />
      ))}
    </>
  );
}
